module.exports = __webpack_public_path__ + "5ec84bd57a79d3d09369ae37d61b5e2e.png";